import React from "react";
import { MapControl } from "@vis.gl/react-google-maps";

import { AutocompleteCustomHybrid } from "src/components/ui/Maps/AutocompleteCustom";

export const CustomMapControl = ({
  controlPosition,
  onPlaceSelect,
  inputPlaceholder,
}) => {
  return (
    <MapControl position={controlPosition}>
      <div className="autocomplete-control">
        <AutocompleteCustomHybrid placeholder={inputPlaceholder} onPlaceSelect={onPlaceSelect} />
      </div>
    </MapControl>
  );
};
